import { ClaimantShow } from "./ClaimantShow";
import { ClaimantList } from "./ClaimantList";
import { getResourceIcon } from "@/utils/icons";
import { ResourceName } from "@/types";

const ClaimantsIcon = getResourceIcon(ResourceName.CLAIMANTS);

const resource = {
  list: ClaimantList,
  show: ClaimantShow,
  //edit:
  //create:
  icon: ClaimantsIcon,
  recordRepresentation: (record: any) => `${record.name}`,
};

export default resource;
